import React from 'react';
import {
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonText,
  IonButtons,
  IonButton,
  IonIcon} from '@ionic/react';
import './PricingPage.css';
import { _dict } from '../components/constants';
import { useGlobalStore } from '../components/stateManagement/globalZustand';
import { home } from 'ionicons/icons';

declare global {
    namespace JSX {
      interface IntrinsicElements {
        'stripe-pricing-table': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
      }
    }
  }

const PricingPage: React.FC = () => {
    const { lang } = useGlobalStore();
    const monthlyPrice = 4.99;
    const annualDiscount = 0.2;
    const annualPrice = monthlyPrice * 12 * (1 - annualDiscount);
    const handleHomeButtonClick = () => {
        window.location.href = "/welcome";
    }

    return (
        <IonPage>
            <IonHeader>
                
                <IonToolbar className="intro-heading">

                <IonButtons slot='start' >
                    <IonButton onClick={handleHomeButtonClick}>
                        <IonIcon slot="icon-only" icon={home} />
                    </IonButton>
                </IonButtons>
                    <IonTitle>{_dict.selectThePlanThatSRightForYou[lang]}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonText>
                    <p className="intro-text">
                        <div>{_dict.allPlansComeWith[lang]} <strong>{_dict.aOneMonthFreeTrial[lang]}</strong>.</div>
                        <div>{_dict.startPayingFromTheSecondMonth[lang]}. <strong>{_dict.cancelAnytime[lang]}</strong>.</div>
                    </p>
                </IonText>

                <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
                <stripe-pricing-table pricing-table-id="prctbl_1P8io2ByUHUE7gpky1Wl38ev"
                publishable-key="pk_live_51MhVh2ByUHUE7gpkENhFMyd5fiZtvLI1Qus7x4bKGzuTaefBWvR3ldghyMIz4jsUEXD4J4XsFgXvLGiYDBa6o7gD00C7I6M2lO">
                </stripe-pricing-table>
                <IonText>
                    <p className="intro-text">
                        {_dict.useThePromotionalCode[lang]} <span className="promo-code">LIFETIME10</span> <span className="discount-highlight">{_dict.forAFurther[lang]} 10% {_dict.lifetimeDiscount[lang]}</span>.
                        <br/> 
                        <b>{_dict.validForTheFirst1000SubscribersOnly[lang]}</b>
                        
                    </p>
                </IonText>
            </IonContent>
        </IonPage>
    );
};




export default PricingPage;
